import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Controls } from '../../../../components/controls/Controls';
import { convertAxiosErrorToUserFacingMessage } from '../../../../context/ApiClientContext';
import basicServiceHandler from '../../../../services/basicServiceHandler';

const STATUS_ABBREVIATIONS = {
  accuroSentSMSStatus: 'SS',
  accuroNotSentSMSStatus: 'SN',
  accuroIntakeCompletedStatus: 'IC',
};

export default function AccuroAppointmentStatusSyncButton({
  setting,
  apiClient,
  handleSave,
  setErrorMessage,
}) {
  const { siteId } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const handleSync = async () => {
    basicServiceHandler(
      () => apiClient.getAccuroAppointmentStatuses(siteId),
      (response) => {
        setIsLoading(true);
        const statusAbbreviation = STATUS_ABBREVIATIONS[setting.name];
        if (!statusAbbreviation) {
          throw new Error(`Invalid setting name: ${setting.name}`);
        }
        const matchingStatus = response.data.find(
          (status) => status.statusAbbreviation === statusAbbreviation,
        );

        if (!matchingStatus) {
          throw new Error(`Status not found for ${setting.name}`);
        }

        handleSave(setting, matchingStatus.statusId.toString());
      },
      (error) => {
        setErrorMessage(convertAxiosErrorToUserFacingMessage(error));
      },
      () => {
        setIsLoading(false);
      },
    );
  };

  return (
    <Controls.Button
      text={isLoading ? 'Syncing...' : 'Sync'}
      onClick={handleSync}
      disabled={isLoading}
    />
  );
}

AccuroAppointmentStatusSyncButton.propTypes = {
  setting: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
  }).isRequired,
  apiClient: PropTypes.shape({
    getAccuroAppointmentStatuses: PropTypes.func.isRequired,
  }).isRequired,
  handleSave: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
};
